import GateMonitor from './GateMonitor.jsx';

export default {
  path: '/gate',
  element: <GateMonitor />,
  protected: true,
  permission: 'gates.view',
  standalone: false,
  sidebar: { label: 'البوابات', icon: 'gate', group: 'operations', order: 40 }
};
